<template>
    <div>
        <el-dialog title="修改测点信息" :visible.sync="dialogEdit.show" width="640px" center>
            <el-form ref="formEdit" :model="cedianForm" label-width="86px">

                <!-- 默认展示 -->
                <div class="form-inline">
                    <el-form-item label="监测项目" prop="measureInfo" class="form-group">
                        <el-input v-model="cedianForm.measureInfo" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="参数" prop="monitorParameters" class="form-group">
                        <el-input v-model="cedianForm.monitorParameters" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="测点编号" prop="measureNo" class="form-group">
                        <el-input v-model="cedianForm.measureNo" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="模块序列号" prop="measureModule" class="form-group">
                        <el-input v-model="cedianForm.measureModule"></el-input>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="测点位置" prop="measure_address" class="form-group">
                        <el-input v-model="cedianForm.measure_address"></el-input>
                    </el-form-item>
                     <el-form-item label="次数" prop="measureNumber" class="form-group">
                        <el-input v-model="cedianForm.measureNumber"></el-input>
                    </el-form-item>
                </div>

                <!-- type_edit值为1时展示 -->
                <div v-if="type_edit == 1">
                    <div class="form-inline">
                        <el-form-item label="预警阀值" prop="earlyWarnValue" class="form-group">
                            <el-input v-model="cedianForm.earlyWarnValue"></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值" prop="warnValue" class="form-group">
                            <el-input v-model="cedianForm.warnValue"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-inline">
                        <el-form-item label="预警率" prop="earlyWarnRate" class="form-group">
                            <el-input v-model="cedianForm.earlyWarnRate"></el-input>
                        </el-form-item>
                        <el-form-item label="报警率" prop="warnRate" class="form-group">
                            <el-input v-model="cedianForm.warnRate"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <!-- type_edit值为2时展示 -->
                <div id="type2" v-if="type_edit == 2">
                    <div class="form-inline">
                        <el-form-item label="预警阀值" prop="earlyWarnValue" class="form-group">
                            <el-input v-model="cedianForm.earlyWarnValue"></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值" prop="warnValue" class="form-group">
                            <el-input v-model="cedianForm.warnValue"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <!-- type_edit值为3时展示 -->
                <div id="type3" v-if="type_edit == 3">
                   <div class="form-inline">
                        <el-form-item label="预警阀值1" prop="earlyWarnValue1" class="form-group">
                            <el-input v-model="cedianForm.earlyWarnValue1"></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值1" prop="warnValue1" class="form-group">
                            <el-input v-model="cedianForm.warnValue1"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-inline">
                        <el-form-item label="预警阀值2" prop="earlyWarnValue2" class="form-group">
                            <el-input v-model="cedianForm.earlyWarnValue2"></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值2" prop="warnValue2" class="form-group">
                            <el-input v-model="cedianForm.warnValue2"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <!-- type_edit值为4时展示 -->
                <div id="type4" v-if="type_edit == 4">
                    <div class="form-inline">
                        <el-form-item label="预警阀值1" prop="earlyWarnValue1" class="form-group">
                            <el-input v-model="cedianForm.earlyWarnValue1"></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值1" prop="warnValue1" class="form-group">
                            <el-input v-model="cedianForm.warnValue1"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-inline">
                        <el-form-item label="预警阀值2" prop="earlyWarnValue2" class="form-group">
                            <el-input v-model="cedianForm.earlyWarnValue2"></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值2" prop="warnValue2" class="form-group">
                            <el-input v-model="cedianForm.warnValue2"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-inline">
                        <el-form-item label="预警率1" prop="earlyWarnRate1" class="form-group">
                            <el-input v-model="cedianForm.earlyWarnRate1"></el-input>
                        </el-form-item>
                        <el-form-item label="报警率1" prop="warnRate1" class="form-group">
                            <el-input v-model="cedianForm.warnRate1"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-inline">
                        <el-form-item label="预警率2" prop="earlyWarnRate2" class="form-group">
                            <el-input v-model="cedianForm.earlyWarnRate2"></el-input>
                        </el-form-item>
                        <el-form-item label="报警率2" prop="warnRate2" class="form-group">
                            <el-input v-model="cedianForm.warnRate2"></el-input>
                        </el-form-item>
                    </div>
                    <!-- <div class="form-inline" v-if="cedianNo == '0103' || '0106' ">
                        <el-form-item label="深度" prop="deepValue" class="form-group">
                            <el-input v-model="cedianForm.deepValue"></el-input>
                        </el-form-item>
                    </div>  -->
                </div>

                <!-- 默认展示 -->
                <div class="form-inline">
                    <el-form-item label="异常值" prop="measureOutliers" class="form-group">
                        <el-input v-model="cedianForm.measureOutliers"></el-input>
                    </el-form-item>
                      <el-form-item label="常数值" prop="measureConstantValue" class="form-group">
                        <el-input v-model="cedianForm.measureConstantValue"></el-input>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="别名" prop="measureOutliers" class="form-group">
                        <el-input v-model="cedianForm.alias"></el-input>
                    </el-form-item>
                </div>

            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="dialogEdit.show = false">取消</el-button>
                <el-button type="primary" @click="dialogFormEdit('formEdit')">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'CheckCedianInfo',
        /*prop类型*/
        props:{
          type_edit:'',
          dialogEdit:Object,
          cedianForm:Object
        },
        data () {
            return {

            }
        },
        methods:{
             dialogFormEdit(formEdit){
                this.$refs[formEdit].validate((valid) => {
                    if(valid){
                        axios.post('api/monitor/project/measure/updateMeasure',this.cedianForm).then(res => {
                            console.log('res: ', res);
                            if(res.data.status == 200){
                                this.$message({
                                    type:"success",
                                    message: res.data.datas.values
                                });
                                this.dialogEdit.show = false;
                                this.$emit('updateEdit') // 更新父组件数据视图
                            }
                            return
                        })
                    }else{
                        return false
                    }
                })
            }
        }
    }
</script>

<style>
  .el-dialog__header {
    text-align: center;
    padding: 20px 30px 10px;
    /*background-image: url('../../assets/img/modal_bg.png')*/
    background: linear-gradient(
      -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }

  .el-dialog__title {
    text-align: center;
    font-size: 18px;
    color: #fff;
  }

    .el-form-item{
        margin-bottom: 8px;
    }

</style>

<style scoped>

    .form-group{
        display: inline-block
    }

</style>



// WEBPACK FOOTER //
// src/components/project/EditCedian.vue